import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const admin = axios.create({ baseURL: API });

admin.interceptors.request.use((config) => {
  const token = localStorage.getItem("rsp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminLogin = (email, password) =>
  admin.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => admin.get("/auth/me").then((r) => r.data);

export const createPaper = (b) => admin.post("/admin/papers", b).then((r) => r.data);
export const updatePaper = (id, b) => admin.put(`/admin/papers/${id}`, b).then((r) => r.data);
export const deletePaper = (id) => admin.delete(`/admin/papers/${id}`).then((r) => r.data);

export const createTopic = (b) => admin.post("/admin/topics", b).then((r) => r.data);
export const updateTopic = (id, b) => admin.put(`/admin/topics/${id}`, b).then((r) => r.data);
export const deleteTopic = (id) => admin.delete(`/admin/topics/${id}`).then((r) => r.data);

export const createWriting = (b) => admin.post("/admin/writings", b).then((r) => r.data);
export const updateWriting = (id, b) => admin.put(`/admin/writings/${id}`, b).then((r) => r.data);
export const deleteWriting = (id) => admin.delete(`/admin/writings/${id}`).then((r) => r.data);

export const updateSiteSettings = (b) => admin.put("/admin/site-settings", b).then((r) => r.data);
export const listContacts = () => admin.get("/admin/contacts").then((r) => r.data);
export const deleteContact = (id) => admin.delete(`/admin/contacts/${id}`).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  admin.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const uploadPdf = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return admin.post("/admin/upload-pdf", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export default admin;
